import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "./supabaseclient";
import logo from "./logo.png";
import "./Login.css";

const BRIDGE_URL = "https://ggwxrbocvnivpnwxmyvc.functions.supabase.co/pw-begin";

async function verifyFromConfirmationURL(urlString) {
  try {
    const u = new URL(urlString);
    const token_hash = u.searchParams.get("token") || u.searchParams.get("token_hash");
    const type = u.searchParams.get("type") || "invite";
    if (!token_hash || !type) return { ok: false };
    const { error } = await supabase.auth.verifyOtp({ token_hash, type });
    return { ok: !error };
  } catch { return { ok: false }; }
}

export default function SetPasswordPage() {
  const nav = useNavigate();
  const loc = useLocation();

  const [ready, setReady] = useState(false);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("Checking link…");

  useEffect(() => {
    (async () => {
      setErr(""); setMsg("Checking link…");
      const href = window.location.href;
      const url = new URL(href);

      const conf = url.searchParams.get("confirmation_url");
      if (conf) {
        const r = await verifyFromConfirmationURL(conf);
        if (r.ok) { setReady(true); setMsg(""); return; }
      }

      const hasCode = !!url.searchParams.get("code");
      const hasHashToken = window.location.hash.includes("access_token") || window.location.hash.includes("refresh_token");
      if (hasCode) {
        const { error } = await supabase.auth.exchangeCodeForSession(href);
        if (!error) { setReady(true); setMsg(""); return; }
      } else if (hasHashToken) {
        const { error } = await supabase.auth.getSessionFromUrl({ storeSession: true });
        if (!error) { setReady(true); setMsg(""); return; }
      }

      const e = url.searchParams.get("e");
      if (e) {
        try {
          setMsg("Refreshing link…");
          const r = await fetch(BRIDGE_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: e }),
          });
          const j = await r.json();
          if (j?.ok && j.action_link) {
            const ok = await verifyFromConfirmationURL(j.action_link);
            if (ok) { setReady(true); setMsg(""); return; }
          }
        } catch {}
      }

      setErr("Invalid or expired link.");
      setMsg("");
      nav("/start-reset", { replace: true });
    })();
  }, [loc.key, nav]);

  const save = async (e) => {
    e.preventDefault();
    setErr(""); setMsg("");
    if (pw.length < 8) return setErr("Password must be at least 8 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: pw });
    setLoading(false);
    if (error) setErr(error.message);
    else { setMsg("Password updated."); await supabase.auth.signOut(); nav("/login"); }
  };

  return (
    <div className="login-wrap">
      <form onSubmit={save} className="login-card">
        <img src={logo} alt="Logo" className="logo" />
        <h2 className="login-title">Triple W Storage</h2>

        {!ready && <div className="msg">{msg || "Preparing password page…"}</div>}

        {ready && (
          <>
            <input
              type="password"
              placeholder="New password"
              value={pw}
              onChange={(e)=>setPw(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Confirm password"
              value={pw2}
              onChange={(e)=>setPw2(e.target.value)}
              required
            />
            {err && <div className="err">{err}</div>}
            {msg && !err && <div className="msg">{msg}</div>}
            <button disabled={loading || !pw || !pw2}>
              {loading ? "Saving…" : "Save password"}
            </button>
          </>
        )}

        <a href="/login" className="muted-link">Back to sign in</a>
      </form>
    </div>
  );
}
